export default __webpack_public_path__ + "static/media/add-16px.352c6c32.svg";